module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0124.jpg?v=be73c2f3";